import React, { useState, useEffect } from "react";
import { slice } from "lodash";
import { Link } from "react-router-dom";

// import data from '../databases/packages.json'

export default function HotDestinations(props) {
    
    const [apilink] = useState(
        "../databases/packages.json"
      );
      //const [apilink, setApilink] = useState([])
      const [post, setPost] = useState([]);
      //const [ setIsCompleted] = useState(false);
      const [index] = useState();
      let initialPosts = slice(post, 0, index);
      const getData = (apilink) => {
        fetch(apilink)
          .then((res) => res.json())
          .then((json) => setPost(json))
          .catch((e) => console.log(e));
      };

      useEffect(() => {
        getData(apilink);
      }, [apilink]);

  return (
    <>
    
       <section className="hotDestinations">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="heading">Hot Destinations</h2>
                <div className="row subHotDest">
                    
                    {
        initialPosts.map((item, i) => {
          return (
            <React.Fragment key={item.id}> 
              {(() => {
                return (
                    <div className={`col-6 ${props.cls}`}>
                        <Link to={`/TravelPackages/${item.destinationname}`} className={item.photoClass}>
                            <div className="pin"><img src={item.pinImg} alt="" /></div>
                            <img src={`${item.destinationImg}`} alt=""/>
                            <h4>{ `${item.destinationname}`}</h4>
                        </Link>
                    </div>
                    );
                    
                  })()}
                </React.Fragment>
              );
            })}
                </div>
            </div>
        </div>
    </div>
</section>
    </>
  )
}
